module.exports = __webpack_public_path__ + "img/MFT白皮书_22.31149af2.jpg";